<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="row">
      <div class="col-lg-12">
        <base-button type="info" @click.prevent="onRefresh" icon>
          <span class="btn-inner--icon">
            <i class="ni refresh-02"></i>
          </span>Refresh
        </base-button>
      </div>
    </div>
    <el-table :data="tableData" row-key="id" header-row-class-name="thead-light">
      <el-table-column label="full name" prop="studentname"></el-table-column>
      <el-table-column label="Start date" prop="startdate"></el-table-column>
      <el-table-column label="End date" prop="enddate"></el-table-column>
      <el-table-column label="Amount" prop="amount"></el-table-column>
      <el-table-column label="paid" prop="paidsum"></el-table-column>
      <el-table-column label="debt" prop="debt"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { GetClassStudentsDebt } from "../../../services/payments";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  name: "students-debt",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Loading,
    flatPicker,
  },
  props: {
    paymentId: String,
  },
  data() {
    return {
      tableData: [],
      isLoading: false,
    };
  },
  methods: {
    onRefresh() {
      this.loadStudents();
    },
    loadStudents() {
      if (!this.paymentId) return;
      this.isLoading = true;
      GetClassStudentsDebt(this.paymentId).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.tableData = response.data.result;
        } else {
          this.tableData = [];
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
  },
  mounted() {
    this.loadStudents();
  },
};
</script>
